/* MALIHA_BILINGUAL_2026 — see maliha-bilingual-2026.css */
(function () {
  var AR = /[؀-ۿ]/g, LAT = /[A-Za-z]/g;
  var isLtrPage = document.documentElement.getAttribute('dir') !== 'rtl';
  var isEnglish = /^en/i.test(document.documentElement.getAttribute('lang') || '');
  var SEL = '.hdt-rte, .hdt-product-description';
  function arabicDominant(t) {
    var a = (t.match(AR) || []).length, l = (t.match(LAT) || []).length;
    return a > 20 && a >= l;
  }
  function fix(el) {
    if (el.getAttribute('data-mlh-bidi')) return;
    el.setAttribute('data-mlh-bidi', '1');
    if (isLtrPage && arabicDominant(el.textContent || '')) {
      el.setAttribute('dir', 'rtl');
      el.setAttribute('lang', 'ar');
      el.classList.add('mlh-ar-block');
    }
    var ps = el.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      var t = (ps[i].textContent || '').trim();
      if (t && t.length <= 40 && /[:：]$/.test(t)) ps[i].classList.add('mlh-rte-label');
    }
  }
  function run(root) {
    var list = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) fix(list[i]);
  }

  /* English pages: show the currency as "IQD" instead of the Arabic "د.ع" (Arabic pages unchanged). */
  var IQD_AR = 'د.ع';
  function fixFormats() {
    var s = window.themeHDN && window.themeHDN.settings;
    if (!s) return;
    ['currencyFormat', 'moneyFormat', 'moneyWithCurrencyFormat'].forEach(function (k) {
      if (typeof s[k] === 'string' && s[k].indexOf(IQD_AR) > -1) s[k] = s[k].split(IQD_AR).join('IQD');
    });
  }
  function swapCurrency(root) {
    if (!isEnglish || !root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.nodeValue.indexOf(IQD_AR) > -1 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
    });
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) {
      var p = nodes[i].parentNode;
      if (p && (p.tagName === 'SCRIPT' || p.tagName === 'STYLE')) continue;
      nodes[i].nodeValue = nodes[i].nodeValue.split(IQD_AR).join('IQD');
    }
  }
  if (isEnglish) { fixFormats(); swapCurrency(document.body); }

  function onReady() { run(); if (isEnglish) { fixFormats(); swapCurrency(document.body); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();
  // Quick view / drawers / variant changes load content later
  var pending = false;
  new MutationObserver(function (records) {
    if (isEnglish) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'characterData') swapCurrency(r.target.parentNode);
        for (var j = 0; j < r.addedNodes.length; j++) {
          var a = r.addedNodes[j];
          swapCurrency(a.nodeType === 3 ? a.parentNode : a);
        }
      }
    }
    if (pending) return; pending = true;
    setTimeout(function () { pending = false; run(); }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
